import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageBase from '../PageBase/PageBase';
import { useApi } from '../../api/api';
import { RegionDataProvider } from '../../contexts/providers/RegionDataProvider';
import '../../styles/insightCards.css';

interface RegionData {
  fishery_management_region_id?: number;
  fishery_management_region_name?: string;
}

export default function Region(): React.ReactElement {
  const { regionSlug } = useParams<{ regionSlug?: string }>();
  const { getRegionBySlug } = useApi();
  const [region, setRegion] = useState<RegionData | null>(null);
  const effectiveRegionSlug = regionSlug || 'new-england';

  useEffect(() => {
    const fetchRegion = async () => {
      if (!effectiveRegionSlug) return;
      try {
        const regionResponse = await getRegionBySlug(effectiveRegionSlug);
        const regionData = regionResponse?.data as RegionData | undefined;
        setRegion(regionData ?? null);
      } catch (err) {
        console.error('Error fetching region:', err);
      }
    };
    fetchRegion();
  }, [effectiveRegionSlug, getRegionBySlug]);

  const pageId = region?.fishery_management_region_id ?? null;

  return (
    <RegionDataProvider regionSlug={effectiveRegionSlug}>
      <PageBase
        pageType="region"
        resourceId={pageId}
        leftPanelTitle="Fishery Management Adjustments"
        rightPanelTitle={`${region?.fishery_management_region_name ?? 'Region'} Fisheries Performance`}
        panelLayoutProps={{}}
        topPanelModules={null}
        bottomPanelVisible={true}
      />
    </RegionDataProvider>
  );
}
